export default __webpack_public_path__ + "static/media/soal no 3.a200ac4f.png";